export default __webpack_public_path__ + "static/media/play.894d808c.svg";